
export const API1 = '/api1'; // gaze
export const API2 = '/api2'; // 纳米盒
export const API3 = '/api3'; // 纳米盒
export const API4 = '/api4'; // 官网


